import * as classNames from 'classnames';
import React from 'react';
import './TooltipStyles.scss';

export default function Tooltip(props) {
  const {
    onClick = () => {},
    content = '',
    tooltipContent = '',
    className = '',
  } = props;

  return (
    <div onClick={onClick} className={classNames('block-tooltip', className)}>
      <div className="tooltip-content">{content}</div>
      <div className="tooltip-popup">{tooltipContent || content}</div>
    </div>
  );
}
